import React, {useEffect, useState} from 'react';
import './style.scss';

const LOCAL_STATE = {
  NORMAL: 'normal',
  WARNING: 'warning',
  DANGER: 'danger',
}

export const GameTimer = ({seconds, freeze, onEdge, onStop}) => {
  const [state, setState] = useState(LOCAL_STATE.NORMAL);
  const [time, setTime] = useState(seconds);
  const [timer, setTimer] = useState(null);

  useEffect(() => {
    if (true === freeze) {
      window.clearInterval(timer);
    } else {
      let _timer = window.setInterval(() => {
        setTime((time) => {
          if (time === 0) {
            window.clearInterval(_timer);
            return 0;
          } else return time - 1;
        });
      }, 1000);
      setTimer(_timer);
    }

    return () => {
      window.clearInterval(timer);
    };
  }, [freeze]);

  useEffect(() => {
    if ([50, 40, 30, 20, 10].includes(time)) {
      onEdge(time);
    }

    if (time === 20) {
      setState(LOCAL_STATE.WARNING);
    } else if (time === 10) {
      setState(LOCAL_STATE.DANGER);
    } else if (time === 0) {
      onStop(true);
    }
  }, [time]);

  return <div className={'app-game-timer app-game-timer_' + state}>
    <span>{`${Math.floor(time / 60)}`.padStart(2, 0)}</span>:<span>{`${time % 60}`.padStart(2, 0)}</span></div>
}
